<style scoped lang="sass">
.round-selector
  display: flex
  justify-content: flex-start
  align-items: center
  margin-bottom: 1rem
  .label
    margin-right: 1rem
  >a
    display:          flex
    justify-content:  center
    align-items:      center
    text-decoration:  none
    margin-right:     0.25rem
    width:            2rem
    height:           2rem
    border-radius:    1rem
    background-color: white
    color:            var(--blue)
    margin-right:     0.5rem
    &.active, &:active, &:hover, &:focus
      background-color: var(--blue)
      color: white
table
  width: 100%
  font-size: 0.8rem
  th, td
    text-align: center
    .collapser
      display: inline-block
      .score
        display: flex
        justify-content: center
        align-items: center
        width: 1.2rem
        height: 1.2rem
        border-radius: 0.6rem
        &.double-bogey
          background-color: #ee5a00
        &.bogey
          background-color: #f7b942
        &.birdie
          background-color: #aed4f6
        &.eagle
          background-color: #32b1e4
      
</style>
<template>
  <pinhigh-modal :on-close="onClose">
    <div class="scorecard-modal">
      <div style="font-weight: bold; margin-bottom: 0.5rem">
        {{tournamentPlayer.player_id}}
      </div>
      <div class="round-selector" v-if="rounds.length">
        <div class="label">Rounds:</div>
        <a href="#" @click.prevent="selectRound(round.number)" v-for="round in rounds" :class="{active: round.number === currentRoundNumber}">{{round.number}}</a>
      </div>
      <div v-else>
        No scorecard data available
      </div>
      <div v-if="currentRound">
        <table class="round">
          <thead>
            <tr>
              <th></th>
              <th v-for="holeNumber in frontSideHoleNumbers">{{holeNumber}}</th>
              <th>OUT</th>
              <th>TOT</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PAR</td>
              <td v-for="holeNumber in frontSideHoleNumbers">{{allHoles[holeNumber].par}}</td>
              <td>{{frontSideParTotal}}</td>
              <td>{{totalPar}}</td>
            </tr>
            <tr>
              <td></td>
              <td v-for="holeNumber in frontSideHoleNumbers">
                <div class="collapser">
                  <span class="score" :class="[overUnderClass(allHoles[holeNumber].par, allHoles[holeNumber].strokes)]">{{allHoles[holeNumber].strokes | pinhighDisplayStrokes}}</span>
                </div>
              </td>
              <td>{{finishedFrontSide ? frontSideStrokesTotal : '-'}}</td>
              <td>{{finished ? totalStrokes : '-'}}</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th></th>
              <th v-for="holeNumber in backSideHoleNumbers">{{holeNumber}}</th>
              <th>IN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>PAR</td>
              <td v-for="holeNumber in backSideHoleNumbers">{{allHoles[holeNumber].par}}</td>
              <td>{{backSideParTotal}}</td>
              <td>{{totalPar}}</td>
            </tr>
            <tr>
              <td></td>
              <td v-for="holeNumber in backSideHoleNumbers">
                <div class="collapser">
                  <span class="score" :class="[overUnderClass(allHoles[holeNumber].par, allHoles[holeNumber].strokes)]">{{allHoles[holeNumber].strokes | pinhighDisplayStrokes}}</span>
                </div>
              </td>
              <td>{{finishedBackSide ? backSideStrokesTotal : '-'}}</td>
              <td>{{finished ? totalStrokes : '-'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </pinhigh-modal>
</template>
<script>
import api from '../api';

export default {
  name: 'ScorecardModal',
  props: {
    tournamentPlayer:   Object,
    onClose:            Function
  },
  data() {
    return {
      currentRoundNumber: 0,
      rounds:             []
    };
  },
  created() {
    api.TournamentPlayerRounds.index({params: {id: this.tournamentPlayer.id}})
      .then(rounds => {
        this.rounds          = rounds;
        this.currentRoundNumber = this.rounds.reduce((memo, {number}) => (number > memo ? number : memo), 0);
      });
  },
  computed: {
    frontSideHoleNumbers() {
      return [1,2,3,4,5,6,7,8,9];
    },
    backSideHoleNumbers() {
      return [10,11,12,13,14,15,16,17,18];
    },
    holeNumbers() {
      return [...this.frontSideHoleNumbers, ...this.backSideHoleNumbers];
    },
    currentRound() {
      return this.currentRoundNumber > 0 ?
        this.rounds.find(({number}) => number === this.currentRoundNumber) :
        null;
    },
    currentRoundHoles() {
      return this.currentRound ?
        this.currentRound.info.reduce((memo,hole) => (memo[hole.hole] = hole, memo), {}) :
        {};
    },
    allHoles() {
      return this.holeNumbers.reduce((memo,number) => (memo[number] = this.currentRoundHoles[number] || {}, memo), {});
    },
    finishedFrontSide() {
      return this.frontSideHoleNumbers.every(number => (this.currentRoundHoles[number] || {}).strokes);
    },
    finishedBackSide() {
      return this.backSideHoleNumbers.every(number => (this.currentRoundHoles[number] || {}).strokes);
    },
    finished() {
      return this.finishedFrontSide && this.finishedBackSide;
    },
    frontSideParTotal() {
      const total = this.frontSideHoleNumbers.reduce((memo,number) => (memo = memo + ((this.currentRoundHoles[number] || {}).par || 0), memo), 0);
      return total > 0 ? total : null;
    },
    backSideParTotal() {
      const total = this.backSideHoleNumbers.reduce((memo,number) => (memo = memo + ((this.currentRoundHoles[number] || {}).par || 0), memo), 0);
      return total > 0 ? total : null;
    },
    frontSideStrokesTotal() {
      const total = this.frontSideHoleNumbers.reduce((memo,number) => (memo = memo + ((this.currentRoundHoles[number] || {}).strokes || 0), memo), 0);
      return total > 0 ? total : null;
    },
    backSideStrokesTotal() {
      const total = this.backSideHoleNumbers.reduce((memo,number) => (memo = memo + ((this.currentRoundHoles[number] || {}).strokes || 0), memo), 0);
      return total > 0 ? total : null;
    },
    totalPar() {
      const total = this.frontSideParTotal + this.backSideParTotal;
      return total > 0 ? total : null;
    },
    totalStrokes() {
      const total = this.frontSideStrokesTotal + this.backSideStrokesTotal;
      return total > 0 ? total : null;
    }
  },
  methods: {
    selectRound(number) {
      this.currentRoundNumber = number;
    },
    overUnderClass(par, strokes) {
      let a = null;
      if (par && strokes) {
        if (par - strokes <= -2) {
          a = 'double-bogey';
        } else if (par - strokes === -1) {
          a = 'bogey';
        } else if (par - strokes === 1) {
          a = 'birdie';
        } else if (par - strokes >= 2) {
          a = 'eagle';
        }
      }
      return a;
    }
  }
};
</script>
